import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export default ({ component: Component, props: cProps, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      return !cProps.isLoggedIn ? (
        <Component {...props} {...cProps} />
      ) : (
        <Redirect
          to={{
            pathname: '/domain',
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);



// WEBPACK FOOTER //
// ./src/helpers/RequireNotAuth.js